module.exports = __webpack_public_path__ + "static/image_3-c7c52fe95648805f31f3fe2f852037de.jpg";